<template>
  <div>
    <PageAllow controller="MaterialProfit" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="overflow-y-scroll fill-content-height">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="exportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("materialProfitAnalyze.Export.excel") }}
              </v-btn>
              <!-- 日期毛利导出 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="materialDateExportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("materialProfitAnalyze.Export.materialDateExcel") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="material"
                    v-model="options.keyword"
                    @text="Keyword = $event"
                    :label="$t('materialProfitAnalyze.Fields.material')"
                  />
                </v-col>
                <!-- 仓库 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStocks v-model="stocksSelected" />
                </v-col>
                <!-- 分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterialCategoriesWithDescendants
                    v-model="materialCategorySelected"
                  />
                </v-col>
                <!-- 客户 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherShops v-model="shopsSelected" />
                </v-col>
                <!-- 分组 -->
                <v-col cols="12" sm="6" md="4" 
                    v-if="
                      settings && settings.report_hide_search_district_tree == 2
                    ">
                  <SearcherDistrictsWithDescendants
                    v-model="DistrictsSelected"
                    :label="
                      $t('shopDailyReports.shopDistricts', [$consts.shopName()])
                    "
                  />
                </v-col>
                <!-- 销售 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherAlliances v-model="alliancesSelected" />
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <SearcherSuppliers
                    ref="supplierSelected"
                    v-model="supplierSelected"
                    :label="$t('Material.default_supplier')"
                  />
                </v-col>
                <!-- 状态 -->
                <v-spacer />
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('materialProfitAnalyze.status.ObjectName')"
                    :items="$consts.materialProfitStatus"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="material_profit_analyze"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 合计 -->
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td colspan="4">
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ sale_total | formatMoney }}</span
                  >
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>{{ num_total }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ cost_total | formatMoney }}</span
                  >
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ profit_total | formatMoney }}</span
                  >
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ profit_total_rate | formatTwoDot(true)
                    }}{{ $t("Global.rate") }}</span
                  >
                </td>
              </tr>
              <!-- 小屏幕 -->
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("materialProfitAnalyze.Fields.sale_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ sale_total | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("materialProfitAnalyze.Fields.nums_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ num_total | formatTwoDot }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("materialProfitAnalyze.Fields.cost_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ cost_total | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("materialProfitAnalyze.Fields.profit_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ profit_total | formatMoney }}
                  </div>
                </td>

                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("materialProfitAnalyze.Fields.profit_total_rate") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ profit_total_rate | formatTwoDot(true)
                    }}{{ $t("Global.rate") }}
                  </div>
                </td>
              </tr>
            </template>

            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.material_standard_name="{ item }">
              <span v-if="item.material_standard_name && item.material_standard_name.length > 12" :title="item.material_standard_name" style="cursor: pointer">
                {{ item.material_standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.material_standard_name }}
              </span>
            </template>
            <!-- 毛利率 -->
            <template v-slot:item.profit_rate="{ item }">
              {{ item.profit_rate | formatTwoDot(true) }}{{ $t("Global.rate") }}
            </template>
            <!-- 销售额 -->
            <template v-slot:item.sale_amount="{ item }">
              {{ $t("Global.money") }}{{ item.sale_amount | formatMoney }}
            </template>
            <!-- 毛利 -->
            <template v-slot:item.profit="{ item }">
              {{ $t("Global.money") }}{{ item.profit | formatMoney }}
            </template>
            <!-- 成本 -->
            <template v-slot:item.cost="{ item }">
              {{ $t("Global.money") }}{{ item.cost | formatMoney }}
            </template>
            <!-- 数量 -->
            <template v-slot:item.num_total="{ item }">
              {{ item.num_total | formatWithDot(2) }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherStocks from "@/components/plugins/SearcherStocks";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import materialProfitAnalyze from "@/api/material_profit_analyze";
import SearcherAlliances from "@/components/plugins/SearcherAlliances";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import Shops from "@/api/shops";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";
import SearcherSuppliers from "@/components/plugins/SearcherSuppliers.vue";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",

  actual_time_from: "",
  actual_time_to: "",

  keyword: "",
  alliance_business_ids: [],
  shop_ids: [],
  // district_id: "",
  status: [4, 5, 6],
  district_ids: [],
  default_supplier_ids: [],
};

export default {
  data: () => ({
    material_profit_analyze: [],
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    profit_total_rate: 0,
    profit_total: 0,
    cost_total: 0,
    sale_total: 0,
    num_total: 0,
    alliancesSelected: null,
    shopsSelected: null,
    DistrictsSelected: [],
    supplierSelected: [],
    stocksSelected: [],
    materialCategorySelected: [],
  }),
  components: {
    SearcherSuppliers,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    PageAllow,
    SearcherAlliances,
    SearcherShops,
    SearcherStatus,
    SearcherStocks,
    SearcherMaterialCategoriesWithDescendants,
    SearcherKeyword,
    SearcherDistrictsWithDescendants,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.profitAnalyze"),
        disabled: false,
        href: "/order-profit",
      },
      {
        text: i18n.t("Nav.materialProfit"),
        disabled: true,
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("materialProfitAnalyze.Fields.created_date"),
      },
      {
        key: "actual",
        text: i18n.t("materialProfitAnalyze.Fields.actual_time"),
      },
    ],
    headers() {
      var headers = [];
      return headers.concat([
        {
          text: i18n.t("materialProfitAnalyze.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("materialProfitAnalyze.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("materialProfitAnalyze.Fields.standard_name"),
          align: "start",
          sortable: false,
          value: "material_standard_name",
        },
        {
          text: i18n.t("materialProfitAnalyze.Fields.category_name"),
          align: "end",
          sortable: false,
          value: "category_name",
        },
        // 销售额
        {
          text: i18n.t("materialProfitAnalyze.Fields.sale_amount"),
          align: "end",
          sortable: false,
          value: "sale_amount",
        },
        // 数量
        {
          text: i18n.t("materialProfitAnalyze.Fields.num_total"),
          align: "end",
          sortable: false,
          value: "num_total",
        },
        // 成本
        {
          text: i18n.t("materialProfitAnalyze.Fields.cost"),
          align: "end",
          sortable: false,
          value: "cost",
        },
        // 毛利
        {
          text: i18n.t("materialProfitAnalyze.Fields.profit"),
          align: "end",
          sortable: false,
          value: "profit",
        },
        // 毛利率
        {
          text: i18n.t("materialProfitAnalyze.Fields.profit_rate"),
          align: "end",
          sortable: false,
          value: "profit_rate",
        },
      ]);
    },
    ...mapState(["settings", "districtID"]),
  },

  mounted() {
    if (this.$route.query.dateType) {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      if (this.$route.query.dateType == "today") {
        this.options.created_time_from =
          new Date(new Date().getTime()).toISOString().substr(0, 10) +
          " 00:00:00";
        this.options.created_time_to =
          new Date().toISOString().substr(0, 10) + " 23:59:59";
      }
      if (this.$route.query.dateType == "yesterday") {
        this.options.created_time_from =
          new Date(new Date().getTime() - 1 * 24 * 3600 * 1000)
            .toISOString()
            .substr(0, 10) + " 00:00:00";
        this.options.created_time_to =
          new Date(new Date().getTime() - 1 * 24 * 3600 * 1000)
            .toISOString()
            .substr(0, 10) + " 23:59:59";
      }
      sessionStorage.setItem(
        "shop_profit_analyze-options",
        JSON.stringify(this.options)
      );
    }
    this.getShopFromAPI();
    this.$store.commit("districtID", 0);
    this.$store.commit(
      "searchDistrict",
      this.settings && this.settings.report_hide_search_district_tree == 1
        ? true
        : false
    );
    this.$commonUtils
      .loadOptions("material_profit_analyze", [
        "alliancesSelected",
        "shopsSelected",
        "stocksSelected",
        "materialCategorySelected",
        "DistrictsSelected",
        "supplierSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "alliancesSelected":
                this.alliancesSelected = selected.value;
                break;
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
              case "materialCategorySelected":
                this.materialCategorySelected = selected.value;
                break;
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
              case "supplierSelected":
                this.supplierSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign(this.options, {
        keyword: this.Keyword,
      });
      this.getMaterialAnalyzeFromAPI();
    },
    resetSearch() {
      this.alliancesSelected = [];
      this.shopsSelected = [];
      this.supplierSelected = [];
      this.DistrictsSelected = [];
      this.stocksSelected = [];
      this.materialCategorySelected = [];

      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getMaterialAnalyzeFromAPI() {
      this.loading = true;
      // 时间参数替换
      var options = Object.assign({}, this.options, {
        // district_id: this.districtID,
        order_created_from: this.options.created_time_from,
        order_created_to: this.options.created_time_to,
        order_actual_from: this.options.actual_time_from,
        order_actual_to: this.options.actual_time_to,
      });
      delete options.created_time_from;
      delete options.created_time_to;
      delete options.actual_time_from;
      delete options.actual_time_to;
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      materialProfitAnalyze.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.material_profit_analyze =
              response.data.material_profit_analyze;
            this.profit_total_rate = response.data.profit_total_rate;
            this.profit_total = response.data.profit_total;
            this.num_total = response.data.num_total;
            this.sale_total = response.data.sale_total;
            this.cost_total = response.data.cost_total;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    exportExcel() {
      // 时间参数替换
      var options = Object.assign({}, this.options, {
        // district_id: this.districtID,
        order_created_from: this.options.created_time_from,
        order_created_to: this.options.created_time_to,
        order_actual_from: this.options.actual_time_from,
        order_actual_to: this.options.actual_time_to,
      });
      delete options.created_time_from;
      delete options.created_time_to;
      delete options.actual_time_from;
      delete options.actual_time_to;
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      materialProfitAnalyze.exports(options);
    },
    materialDateExportExcel() {
      // 时间参数替换
      var options = Object.assign({}, this.options, {
        // district_id: this.districtID,
        order_created_from: this.options.created_time_from,
        order_created_to: this.options.created_time_to,
        order_actual_from: this.options.actual_time_from,
        order_actual_to: this.options.actual_time_to,
      });
      delete options.created_time_from;
      delete options.created_time_to;
      delete options.actual_time_from;
      delete options.actual_time_to;
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      materialProfitAnalyze.materialDateExport(options);
    },

    getShopFromAPI() {
      if (this.$route.query.shop_id) {
        Shops.fetchOne(this.$route.query.shop_id).then(
          function (response) {
            if (response.data.status.isOK()) {
              var shop = response.data.shop;
              this.shopsSelected = [shop];
            }
          }.bind(this)
        );
      }
    },
  },
  watch: {
    districtID: {
      handler() {
        this.getMaterialAnalyzeFromAPI();
      },
    },
    options: {
      deep: true,
      handler() {
        this.getMaterialAnalyzeFromAPI();
        sessionStorage.setItem(
          "material_profit_analyze-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 销售
    alliancesSelected: {
      handler() {
        this.options.alliance_business_ids = this.alliancesSelected
          ? this.alliancesSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "material_profit_analyze-alliancesSelected",
          JSON.stringify(this.alliancesSelected)
        );
      },
    },
    // 门店
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "material_profit_analyze-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    supplierSelected: {
      handler() {
        this.options.default_supplier_ids = this.supplierSelected.map((s) => s.id);
        sessionStorage.setItem(
            "material_profit_analyze-supplierSelected",
            JSON.stringify(this.supplierSelected)
        );
      },
    },
    DistrictsSelected: {
      handler() {
        if (this.settings &&
          this.settings.report_hide_search_district_tree == 2)
        { 
          this.options.district_ids = this.DistrictsSelected
            ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
            : [];
          sessionStorage.setItem(
            "material_profit_analyze-DistrictsSelected",
            JSON.stringify(this.DistrictsSelected)
          );
        }
      },
    },
    // 仓库
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected.map((e) => e.id);
        sessionStorage.setItem(
          "material_profit_analyze-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
    // 商品分类
    materialCategorySelected: {
      handler() {
        this.options.category_ids = this.materialCategorySelected.map(
          (category) => category.id
        );
        sessionStorage.setItem(
          "material_profit_analyze-materialCategorySelected",
          JSON.stringify(this.materialCategorySelected)
        );
      },
    },
    settings: {
      handler() {
        this.$store.commit(
          "searchDistrict",
          this.settings && this.settings.report_hide_search_district_tree == 1
            ? true
            : false
        );
      },
    },
  },
};
</script>

<style>
</style>